import { writeWml } from '../document/utils/wmlUtils.js';
import path from 'path';
import { createDefaultPageCodeFile } from '../code/utils/veloUtils.js';
const generatePageFolderPathByInfo = (state, pageInfo) => {
    const pagePath = state.fileStructure.getPagesPathsForType(pageInfo.type);
    return path.join(...pagePath.map(entry => entry.type === 'Folder' ? entry.name : pageInfo[entry.variableName]));
};
const escapeRegexSpecialChars = (str) => str.replace(/[.*+?^=!:${}()|[\]/\\]/g, '\\$&');
const isPathFormatMatching = (fullPath, basePath) => new RegExp(`^${escapeRegexSpecialChars(basePath)}(?: \\((\\d*)\\))?$`).test(fullPath);
const generateNewPagePath = (state, pageInfo, existingPageFolderPath) => {
    let pageFolderPath = generatePageFolderPathByInfo(state, pageInfo);
    if (existingPageFolderPath && isPathFormatMatching(existingPageFolderPath, pageFolderPath)) {
        return existingPageFolderPath;
    }
    while (state.pages.getPageId(pageFolderPath)) {
        pageFolderPath = incrementPathSuffix(pageFolderPath);
    }
    return pageFolderPath;
};
const createPageFiles = async (state, folderPath, pageData) => {
    const pageStructure = state.fileStructure.getPageFilesPaths(folderPath);
    await Promise.all([
        writeWml(state.fileSystem, pageStructure.document, pageData),
        createDefaultPageCodeFile(state.fileSystem, pageStructure.code)
    ]);
};
export const createPage = async (state, pageId, pageData) => {
    const newPageFolder = generateNewPagePath(state, pageData.info);
    await state.fileSystem.createFolder(newPageFolder);
    await createPageFiles(state, newPageFolder, pageData);
    state.pages.addPage(pageId, newPageFolder);
};
export const removePage = async (state, pageId) => {
    const folderPath = state.pages.getFolderPath(pageId);
    if (!folderPath)
        return;
    await state.fileSystem.removeFolder(folderPath);
    state.pages.removePageById(pageId);
};
export const updatePage = async (state, pageId, existingPageFolderPath, pageData) => {
    const expectedFolderPath = generateNewPagePath(state, pageData.info, existingPageFolderPath);
    if (existingPageFolderPath !== expectedFolderPath) {
        await removePage(state, pageId);
        await createPage(state, pageId, pageData);
        return;
    }
    const pageStructure = state.fileStructure.getPageFilesPaths(existingPageFolderPath);
    await writeWml(state.fileSystem, pageStructure.document, pageData);
};
export const incrementPathSuffix = (path) => {
    const [, origPath, suffix = 1] = path.match(/^(.*?)(?: \((\d+)\))?$/) ?? [];
    return `${origPath} (${Number(suffix) + 1})`;
};
